/* eslint-disable import/prefer-default-export */

import { makeEntityScaffold } from '@classpass/saga-tools';

export const fitnessDeviceTracking = makeEntityScaffold(
  'SAGA.API.FITNESS_DEVICE_TRACKING',
  (client, deviceInfo, options = {}) =>
    client.fitness.trackDevice(deviceInfo, options).then(data => data.fitness_device_id)
);
